import React, { useEffect } from 'react';
import './LegalPage.css';

const TermsOfService = ({ onBack }) => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="legal-page">
      <div className="legal-nav">
        <div className="legal-logo" onClick={onBack}>
          Umpire<span>IQ</span>
        </div>
        <button className="legal-back" onClick={onBack}>← Back</button>
      </div>

      <div className="legal-inner">
        <div className="legal-header">
          <div className="legal-eyebrow">Legal</div>
          <h1>Terms of Service</h1>
          <p className="legal-effective">Effective Date: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
        </div>

        <div className="legal-body">

          <p>These Terms of Service ("Terms") constitute a binding legal agreement between you and GOLF DATA ASSESSORS LLC ("UmpireIQ," "we," "us," or "our"), a Wyoming limited liability company operating umpire-iq.com (the "Platform"). By accessing or using the Platform, you agree to be bound by these Terms. If you do not agree, do not use the Platform.</p>

          <h2>1. Eligibility</h2>
          <p>The Platform is intended for licensed insurance professionals, including but not limited to public adjusters, independent appraisers, appraisal umpires, claims attorneys, and related professionals. By registering, you represent that:</p>
          <ul>
            <li>You are at least 18 years of age</li>
            <li>You are a licensed professional in good standing in your state(s) of practice</li>
            <li>You are registering with a valid business email address</li>
            <li>The information you provide is accurate and truthful</li>
          </ul>

          <h2>2. Accounts</h2>
          <p>You are responsible for maintaining the confidentiality of your account credentials. You agree to notify us immediately of any unauthorized use of your account. We reserve the right to suspend or terminate accounts that violate these Terms or that we determine, in our sole discretion, to be harmful to the Platform or its users.</p>

          <h2>3. User-Generated Content</h2>
          <h3>3.1 Your Content</h3>
          <p>You are solely responsible for all ratings, endorsements, written content, and other materials you submit to the Platform ("User Content"). By submitting User Content, you grant UmpireIQ a non-exclusive, worldwide, royalty-free license to display, distribute, and use that content in connection with operating the Platform.</p>

          <h3>3.2 Content Standards</h3>
          <p>All User Content must:</p>
          <ul>
            <li>Be based on your direct, firsthand professional experience with the rated individual</li>
            <li>Be factually accurate to the best of your knowledge</li>
            <li>Constitute your honest professional opinion</li>
            <li>Not contain false statements of fact</li>
            <li>Not contain personal attacks, harassment, or threats</li>
            <li>Not violate any applicable law</li>
          </ul>

          <h3>3.3 Pre-Submission Warning</h3>
          <p>Prior to submitting any rating or written content, you will be presented with the following notice, which you must acknowledge:</p>
          <blockquote>
            "Reviews must be based on your direct professional experience. Stick to facts and honest professional opinion. Defamatory or knowingly false statements expose you personally to civil liability — the platform is not responsible for what you write. By posting you confirm this review reflects your genuine experience."
          </blockquote>
          <p>By clicking "Post Review," you acknowledge that you have read, understood, and agreed to this warning.</p>

          <h3>3.4 Platform as Intermediary — Section 230</h3>
          <p>UmpireIQ is an interactive computer service as defined under 47 U.S.C. § 230 (the Communications Decency Act). We are not the publisher or speaker of User Content submitted by third parties. We are not liable for any User Content posted by users of the Platform. Liability for defamatory, false, or otherwise actionable User Content rests solely with the user who submitted it.</p>

          <h2>4. Prohibited Conduct</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Submit false, misleading, or defamatory content about any individual</li>
            <li>Submit ratings or endorsements for individuals you have not personally worked with in a professional appraisal capacity</li>
            <li>Create multiple accounts to manipulate ratings</li>
            <li>Solicit, offer, or accept compensation in exchange for ratings or endorsements</li>
            <li>Contact or attempt to contact any user to pressure them to modify or remove a rating</li>
            <li>Attempt to identify the submitter of any anonymized content</li>
            <li>Use the Platform for any unlawful purpose</li>
            <li>Scrape, harvest, or systematically collect data from the Platform</li>
            <li>Interfere with or disrupt the operation of the Platform</li>
            <li>Impersonate any person or entity</li>
          </ul>

          <h2>5. Peer Reviewed Badge Program</h2>
          <h3>5.1 Eligibility and Application</h3>
          <p>The Peer Reviewed badge program is available to Premium subscribers who have an active 12-month Peer Reviewed subscription. Application requires submission of a complete, attested list of all umpire assignments in the preceding 24 months.</p>

          <h3>5.2 Attestation</h3>
          <p>By submitting your assignment list, you certify under penalty of badge revocation and account termination that the list is complete and accurate to the best of your knowledge. Submission of a knowingly incomplete or curated list to influence file selection constitutes a material breach of these Terms.</p>

          <h3>5.3 File Submission Requirements</h3>
          <p>Files submitted for peer review must:</p>
          <ul>
            <li>Be fully redacted of all personally identifiable information including names, addresses, policy numbers, and any information that could identify the insured, the property, or the professionals involved</li>
            <li>Be submitted as flat PDF files</li>
            <li>Include a written narrative as described in the application instructions</li>
          </ul>
          <p>You are solely responsible for adequate redaction. UmpireIQ assumes no liability for inadequate redaction of submitted files.</p>
          <p>Peer reviewers agree that all submitted materials is confidential and 
            for evaluation purposes only. Reviewers are expressly prohibited from 
            printing, screenshotting, photographing, copying, downloading, forwarding, 
            or in any way duplicating or extracting review materials outside the platform 
            interface. Violation of this prohibition constitutes a material breach of 
            these Terms and may result in immediate account termination, forfeiture of 
            reviewer compensation, and civil liability to the submitting umpire and 
            UmpireIQ.</p>

          <h3>5.4 Reviewer Compensation</h3>
          <p>Peer reviewers are compensated $100 per file reviewed through the Platform. UmpireIQ reserves the right to modify reviewer compensation at any time with reasonable notice.</p>

          <h3>5.5 Badge Award and Revocation</h3>
          <p>Badges are awarded at UmpireIQ's sole discretion based on peer review outcomes. Badges may be revoked for violation of these Terms, material change in professional standing, or failure to renew.</p>

          <h2>6. Subscription and Payment</h2>
          <p>Premium subscriptions are billed monthly. Peer Reviewed subscriptions require a 12-month commitment billed monthly. All fees are non-refundable except as required by law. We reserve the right to modify pricing with 30 days notice to active subscribers.</p>

          <h2>7. Intellectual Property</h2>
          <p>All Platform content, design, code, trademarks, is proprietary data and are licensed to GOLF DATA ASSESSORS LLC for operation of the Platform. You may not copy, reproduce, distribute, or create derivative works from Platform content without express written permission.</p>

          <h2>8. NIPR Data and Public Records</h2>
          <p>Profiles for licensed and unclaimed users is generated from publicly available data sourced from the National Insurance Producer Registry (NIPR) and state Departments of Insurance. This data is provided for informational purposes only. UmpireIQ does not warrant the accuracy, completeness, or currency of public records data.</p>

          <h2>9. Disclaimer of Warranties</h2>
          <p>THE PLATFORM IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED. UMPIREIQ DOES NOT WARRANT THAT THE PLATFORM WILL BE UNINTERRUPTED, ERROR-FREE, OR FREE OF HARMFUL COMPONENTS. WE DO NOT ENDORSE, VERIFY, OR WARRANT THE ACCURACY OF ANY USER CONTENT OR PROFILE INFORMATION.</p>

          <h2>10. Limitation of Liability</h2>
          <p>TO THE MAXIMUM EXTENT PERMITTED BY LAW, UMPIREIQ, GOLF DATA ASSESSORS LLC, AND ITS MEMBERS, MANAGERS, OFFICERS, AND AGENTS SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING FROM YOUR USE OF THE PLATFORM OR ANY USER CONTENT. OUR TOTAL LIABILITY FOR ANY CLAIM ARISING FROM THESE TERMS SHALL NOT EXCEED THE AMOUNT YOU PAID TO US IN THE 12 MONTHS PRECEDING THE CLAIM.</p>

          <h2>11. Indemnification</h2>
          <p>You agree to indemnify, defend, and hold harmless UmpireIQ, GOLF DATA ASSESSORS LLC, and its members, managers, officers, and agents from and against any claims, damages, losses, and expenses (including reasonable attorneys' fees) arising from: (a) your use of the Platform; (b) your User Content; (c) your violation of these Terms; or (d) your violation of any third-party rights.</p>

          <h2>12. Anti-SLAPP Notice</h2>
          <p>The State of Wyoming provides statutory protections against Strategic Lawsuits Against Public Participation (SLAPP). Meritless defamation claims filed to silence Platform users may be subject to dismissal and fee-shifting under applicable anti-SLAPP statutes. Users who submit good-faith ratings based on genuine professional experience are protected by both Section 230 and applicable state law.</p>

          <h2>13. Termination</h2>
          <p>We reserve the right to suspend or terminate your account at any time for violation of these Terms. You may close your account at any time by contacting admin@umpire-iq.com. Termination does not entitle you to a refund of prepaid subscription fees.</p>

          <h2>14. Governing Law and Dispute Resolution</h2>
          <p>These Terms are governed by the laws of the State of Wyoming, without regard to conflict of law principles. Any dispute arising from these Terms shall be resolved by binding arbitration in Natrona County, Wyoming, under the rules of the American Arbitration Association, except that either party may seek injunctive relief in a court of competent jurisdiction.</p>

          <h2>15. Changes to These Terms</h2>
          <p>We reserve the right to modify these Terms at any time. Material changes will be communicated to registered users by email at least 14 days before taking effect. Continued use of the Platform after changes take effect constitutes acceptance.</p>

          <h2>16. Contact</h2>
          <p>Questions about these Terms should be directed to:</p>
          <p><strong>GOLF DATA ASSESSORS LLC</strong><br />
          5830 E 2nd St, Ste 7000 #35896<br />
          Casper, Wyoming 82609<br />
          admin@umpire-iq.com</p>

        </div>
      </div>

      <footer className="legal-footer">
        <div className="legal-footer-logo" onClick={onBack}>Umpire<span>IQ</span></div>
        <div className="legal-footer-copy">© {new Date().getFullYear()} Golf Data Assessors, LLC. All rights reserved.</div>
      </footer>
    </div>
  );
};

export default TermsOfService;
